export function chatServiceDomain(gladlySite: string): string {
  const domain = gladlySite.replace(/\.gladly\.(qa|com)$/, '.gladly.chat');
  if (domain === gladlySite) {
    throw new Error(`Could not derive chat service domain from gladlySite: ${gladlySite}`);
  }
  return domain;
}
